export default __webpack_public_path__ + "static/sakhalin_main-f66fba7da36deac7d7ea8fce0848c759.jpg";